let allForms = document.querySelectorAll('form');

allForms.forEach(form => {
    form.addEventListener('submit', function (event) {
        // Get all input elements inside the form
        let formElements = form.querySelectorAll('input, textarea, select, button');
        // Prevent all form elements from receiving user interactions
        formElements.forEach(element => {
            element.style.pointerEvents = 'none';
        });
        // decrease form opacity
        form.style.opacity = 0.5;
        // find and update the submit button value
        let submitButton = form.querySelector('input[type="submit"]');
        if (submitButton) {
            submitButton.value = 'Submitting...';
            submitButton.disabled = true;
        }
    });
});


